import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { getPremiumInfoData } from '../../actions';

const defaultPoints = [
    `10__Unlimited AI note-taking minutes`,

    `20__Unlimited Cloud Storage`,

    `30__File Uploads to AI notes`,

    `40__Youtube Videos to AI notes`,

    `50__Chat with notes, audio, and videos`
];

export default class PremiumPoints extends Component {
    render() {
        // const { premiumInfoLoc } = this.props;
        const premiumInfoLoc = getPremiumInfoData() || {};
        const mainPoints = premiumInfoLoc['points'] || defaultPoints;
        const sortedPoints = [...mainPoints].sort();
        return (
            <div>

                {(sortedPoints).map((point) => (
                    <p key={point} className='serif' style={{ fontSize: '1.1em' }}>
                        <FontAwesomeIcon style={{ color: 'green' }} icon={'check-circle'} />
                        &nbsp; {point.includes('__') ? point.split('__')[1] : point}</p>
                ))}
            </div>
        )
    }
}

PremiumPoints.propTypes = {
    // premiumInfoLoc: PropTypes.object,
    index: PropTypes.number,
}
